import { supportedLinksFormats } from './assets';

const ALLOWED_EXTENSIONS = supportedLinksFormats;

export const VALIDATION_RULES = {
    blocking: [
        'No spaces before the extension (e.g. "photo .jpg")',
        'No leading or trailing spaces',
        'No illegal characters: : * ? " < > |',
        'Must have a supported extension (.jpg, .png, .tif, .pdf, etc.)',
        'No double dots in the name (e.g. "file..jpg")',
        'Filename must not be empty',
        'Filename must not exceed 100 characters',
    ],
    warning: [
        'Avoid accented or unicode characters (e.g. é, ñ, ü)',
        'Avoid special characters: & # % ( ) + [ ] { }',
        'Filename longer than 50 characters may cause issues',
    ]
};

export function validateSingleFilename(filename) {
    const errors = [];
    const warnings = [];

    const lastDotIndex = filename.lastIndexOf('.');
    const hasDot = lastDotIndex >= 0;
    const name = hasDot ? filename.substring(0, lastDotIndex) : filename;
    const ext = hasDot ? filename.substring(lastDotIndex) : '';

    if (name.length === 0) {
        errors.push('Filename is empty (only extension)');
    }

    if (!hasDot || ext === '.') {
        errors.push('File has no extension');
    } else if (!ALLOWED_EXTENSIONS.includes(ext.toLowerCase())) {
        errors.push(`Extension "${ext}" is not supported`);
    }

    if (name.endsWith(' ')) {
        errors.push('Filename contains a space before the extension');
    }

    if (name.startsWith(' ')) {
        errors.push('Filename starts with a space');
    }

    if (filename.endsWith(' ')) {
        errors.push('Filename ends with a space');
    }

    const illegalChars = /[:"*?<>|]/;
    if (illegalChars.test(name)) {
        const found = name.match(/[:"*?<>|]/g);
        errors.push(`Contains illegal characters: ${[...new Set(found)].join(' ')}`);
    }

    if (filename.includes('..')) {
        errors.push('Filename contains ".." (double dot)');
    }

    if (filename.length > 100) {
        errors.push(`Filename is too long (${filename.length} characters, max 100)`);
    } else if (filename.length > 50) {
        warnings.push(`Filename is long (${filename.length} characters, recommended max 50)`);
    }

    const unicodeChars = /[^\x00-\x7F]/;
    if (unicodeChars.test(name)) {
        warnings.push('Filename contains accented or special characters');
    }

    const specialChars = /[&#%\(\)\+\[\]\{\}]/;
    if (specialChars.test(name)) {
        warnings.push('Filename contains special characters (&, #, %, parentheses, +)');
    }

    let status = 'valid';
    if (errors.length > 0) status = 'blocked';
    else if (warnings.length > 0) status = 'warning';

    return { status, errors, warnings };
}

export function validateFilenames(files) {
    return Array.from(files).map(file => {
        const result = validateSingleFilename(file.name);
        return { file, ...result };
    });
}
